import { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ORGANIZATION_TYPE, OrganizationType } from '../../types/organization.type';
import { HomeWork as HomeWorkIcon, Business as BusinessIcon } from '@material-ui/icons';

type OrganizationTypeChipProps = {
  type: OrganizationType;
  size?: 'small' | 'medium';
};

const useStyles = makeStyles(() => ({
  root: (props: { backgroundColor: string; color: string }) => ({
    borderRadius: 4,
    textTransform: 'capitalize',
    backgroundColor: props.backgroundColor,
    color: props.color,

    '& .MuiChip-label': {
      display: 'flex',
      alignItems: 'center',
      gap: 6,

      '& > svg': {
        width: 16,
        height: 16,
        fill: props.color,
      },

      '& > span': {
        fontSize: 12,
        lineHeight: '14px',
      },
    },
  }),
}));

const getChipStyle = (type: OrganizationType): { backgroundColor: string; color: string; icon: React.ReactElement } => {
  switch (type) {
    case ORGANIZATION_TYPE.CONCIERGERY:
      return { backgroundColor: '#4caf50', color: '#ffffff', icon: <HomeWorkIcon /> };
    case ORGANIZATION_TYPE.COMPANY:
      return { backgroundColor: '#2196f3', color: '#ffffff', icon: <BusinessIcon /> };
  }
};

const formatOrganizationType = (type: OrganizationType) => {
  switch (type) {
    case ORGANIZATION_TYPE.CONCIERGERY:
      return 'Conciergerie';
    case ORGANIZATION_TYPE.COMPANY:
      return 'Entreprise';
  }
};

export default function OrganizationTypeChip({ type, size = 'small' }: OrganizationTypeChipProps) {
  const { label, backgroundColor, color, icon } = useMemo(() => {
    return {
      label: formatOrganizationType(type),
      ...getChipStyle(type),
    };
  }, [type]);

  const classes = useStyles({ backgroundColor, color });

  return (
    <Chip
      className={classes.root}
      size={size}
      label={
        <>
          {icon}
          <span>{label}</span>
        </>
      }
    />
  );
}
